import type { FeedbackMessages } from './en';

const ro: FeedbackMessages = {
  qualified: {
    title: 'Vă mulțumim pentru finalizarea acestui studiu!',
    text: 'Puteți închide fereastra browserului.\n\nSperam să vă revedem în curând.',
  },
  quotaFull: {
    title: 'Acest studiu este închis',
    text: 'Vă mulțumim pentru interesul acordat studiului nostru.\n\nDin păcate, am primit deja toate răspunsurile de care avem nevoie.\n\nSperam să vă revedem într-unul din studiile noastre viitoare!',
  },
  terminated: {
    title: 'Vă mulțumim pentru feedback-ul dumneavoastră!',
    text: 'Sperăm să vă revedem în curând în studiile noastre viitoare. Până atunci, vă urăm o zi excelentă.\n\nVă rugăm să închideți această fereastră a browserului.',
  },
  mismatch: {
    title: 'Vă mulțumim pentru interesul dumneavoastră',
    text: 'Din păcate, nu faceți parte din grupul țintă pentru acest studiu specific.\n\nPuteți închide această pagină.',
  },
  error: {
    title: 'Nu putem procesa solicitarea dumneavoastră',
    linkProblemDetailed:
      'Linkul pe care l-ați urmat are probleme. Vă rugăm să verificați că linkul din bara de adrese corespunde cu cel care v-a fost furnizat și încercați din nou.',
    linkProblemGeneric:
      'Linkul pe care l-ați urmat are probleme. Vă rugăm să încercați din nou.',
    contactPerson:
      'Dacă problema persistă, vă rugăm să informați persoana de la care ați primit linkul despre această problemă.',
  },
};

export default ro;
